import './AddAddress.css';
import { useTranslation } from 'react-i18next';
import { BILLING_ADDR_ADDRESS1_INPUT_MAX_LENGTH, ADDRESS_FIELDS_INPUT_MAX_LENGTH } from '../../../../constants/AppConstants';
import { ENVSettings } from '../../../../constants/ENVSettings';
import { getCountryTranslation } from '../../../../constants/AppMethod';
import Loader from '../../../../components/shared/loader/Loader';
import { useSelector } from "react-redux";


function AddAddressForm({ handleContinue, setOpenAddressEditForm, setAddress, address, errors, showChooseExistingText = true, isPostcodeLoading, isBillingAddress }) {
  const { t } = useTranslation();
  const countries = ENVSettings.COUNTRIES;
  const updateBrotherPlusShippingAddressResponse = useSelector(state => state.BROTHERPLUS.updateShippingAddressService);
  const updateEcoProShippingAddressResponse = useSelector(state => state.UpdateShipping);
  const ManageSubscriptionResponse = useSelector(state => state.ManageSubscription);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddress((prev) => ({ ...prev, [name]: value }));
  };

  const chooseExisting = () => {
    if (setOpenAddressEditForm)
    {
      setOpenAddressEditForm(false);
      setAddress(null);
    }
  }
  if (updateBrotherPlusShippingAddressResponse?.loading || updateEcoProShippingAddressResponse?.loading || ManageSubscriptionResponse?.loading) {
    return <Loader />
  }
  return (
    <div className="address-form">
      <div className="header-row">
        <label>{t('MY_DEVICES.ADD_ADDRESS_FORM.LOCATION_NAME_LABEL')} *</label>
        {showChooseExistingText && <span onClick={chooseExisting}>{t('MY_DEVICES.ADD_ADDRESS_FORM.CHOOSE_EXISTING')}</span>}
      </div>

      <input
        type="text"
        name="addressName"
        placeholder=""
        value={address.addressName}
        onChange={handleChange}
        minLength={1}
        maxLength={100}
      />
      <div className="invalid-feedback display-error">{errors?.addressName}</div>

      <label>{t('MY_DEVICES.ADD_ADDRESS_FORM.ADDRESS_LINE_1')} <span>*</span></label>
      <input
        type="text"
        name="addressLine1"
        value={address.addressLine1}
        onChange={handleChange}
        minLength={1}
        maxLength={isBillingAddress ? BILLING_ADDR_ADDRESS1_INPUT_MAX_LENGTH : ADDRESS_FIELDS_INPUT_MAX_LENGTH}
      />
      <div className="invalid-feedback display-error">{errors?.addressLine1}</div>

      <label>{t('MY_DEVICES.ADD_ADDRESS_FORM.ADDRESS_LINE_2')}</label>
      <input
        type="text"
        name="addressLine2"
        value={address.addressLine2}
        onChange={handleChange}
        minLength={0}
        maxLength={ADDRESS_FIELDS_INPUT_MAX_LENGTH}
      />

      <label>{t('MY_DEVICES.ADD_ADDRESS_FORM.CITY_TOWN')} <span>*</span></label>
      <input
        type="text"
        name="cityTown"
        value={address.cityTown}
        onChange={handleChange}
        minLength={1}
        maxLength={ADDRESS_FIELDS_INPUT_MAX_LENGTH}
      />
      <div className="invalid-feedback display-error">{errors?.cityTown}</div>

      <div className="row">
        <div className="half">
          <label>{t('MY_DEVICES.ADD_ADDRESS_FORM.COUNTRY')} <span>*</span></label>
          <select className="add-device ecopro-form-select form-select" name="country" value={address.country} onChange={handleChange}>
            <option defaultValue>--- {t("FORM_CONTENT.FORM_PLACEHOLDER.SELECT_COUNTRY")} ---</option>
            {
              countries.map((data) => {
                return (
                  <option key={data.name} value={data.name}>
                    {getCountryTranslation(data.name)}
                  </option>
                );
              })
            }
          </select>
          <div className="invalid-feedback display-error">{errors?.country}</div>
        </div>
        <div className="half postcode-style">
          <label>{t('MY_DEVICES.ADD_ADDRESS_FORM.POSTCODE')} <span>*</span></label>
          <input
            type="text"
            name="postCode"
            value={address.postCode}
            onChange={handleChange}
            minLength={1}
            maxLength={20} 
          />
          {
            (isPostcodeLoading) &&
            <div className="web-form-input-spinner-wrapper">
              <div className="spinner-border" role="status"></div>
            </div>
          }
          <div className="invalid-feedback display-error">{errors?.postCode}</div>
        </div>
      </div>
      <div className="continue-button from-add-address">
        <button onClick={handleContinue}>{t('MY_DEVICES.ADD_ADDRESS_FORM.ADD_ADDRESS_BUTTON')}</button>
      </div>

    </div>
  );
}

export default AddAddressForm;


